export default {
  SET_DATA_LAST_MANIFEST: (state: any, payload: any) => {
    state.lastManifest = payload
  },
  SET_DATA_LAST_ROUTE: (state: any, payload: any) => {
    state.lastRoute = payload
  },
}
